import svgIcons from "../../../assets/svg/svgIcons";
import PagewideMessageDisplay from "../../../components/pagewideMessageDisplay";
import { APP_CONFIG } from "../../../constants/constants";
import { useChatContext } from "../contexts/chat.context";
import ChatConversation from "./chatConversation";

const ChatMainColumn = () => {
  const {
    subscribedChannels,
    selectedChatChannel,
    channelTransitionInProgress,
    conversations,
    presence,
  } = useChatContext();
  return (
    <>
      {APP_CONFIG.DEBUG.DISPLAY_VERBOSE && (
        <pre className="absolute bg-white/50 flex flex-col text-[10px] max-w-64 bottom-0 left-0 z-10">
          <span>subscribedChannels:</span>
          <span className="bg-accent-blue-pale w-64 h-48 overflow-auto">
            {JSON.stringify(subscribedChannels, null, 2)}
          </span>
          <span>
            subscribedChannels count:{" "}
            {JSON.stringify(subscribedChannels?.length, null, 2)}
          </span>
          <span>
            selectedChatChannel: {JSON.stringify(selectedChatChannel, null, 2)}
          </span>
          <span>
            channelTransitionInProgress:{" "}
            <span
              className={
                channelTransitionInProgress ? "text-field-error-dark" : ""
              }
            >
              {JSON.stringify(channelTransitionInProgress, null, 2)}
            </span>
          </span>
          Conversations:
          <br />
          <span className="bg-accent-blue-pale w-64 h-48 overflow-auto">
            {JSON.stringify(conversations, null, 2)}
          </span>
          Presence:
          <br />
          <span className="bg-accent-blue-pale w-64 h-48 overflow-auto">
            {JSON.stringify(presence, null, 2)}
          </span>
        </pre>
      )}
      {channelTransitionInProgress ? (
        <div className="col-span-8 h-[calc(100vh-160px)] flex items-center justify-center">
          <img
            src={svgIcons.LoadingAnimation}
            alt="loading"
            className="w-12 h-12 m-auto"
          />
        </div>
      ) : !!selectedChatChannel ? (
        <ChatConversation
          key={`chat-conversation-${selectedChatChannel}`}
          wrapperClass="col-span-8 h-[calc(100vh-160px)]"
        />
      ) : (
        <PagewideMessageDisplay
          title="Select a channel"
          description="Please select a channel to start chatting"
        />
      )}
    </>
  );
};
export default ChatMainColumn;
